import typeEntity from '../constants/entity-type';

export const formatEntityType = (entityType, noteType) => {
  if (entityType === typeEntity.TEST_SESSION_NOTE) {
    return noteType === 'clip' ? 'Clip' : 'Notes';
  }

  if (entityType === typeEntity.REPORT) {
    return 'Reports';
  }

  if (entityType === typeEntity.TEST_SESSION_ANSWER || entityType === typeEntity.TEST_SESSION_SPEAKER) {
    return 'Transcript';
  }

  return entityType;
};
